import { useSnackbar } from "../../../utils/notificacoes"
import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterRespostasIzza,
    salvarRespostasIzza,
} from "../../../services/respostasPersonalizadasIzza"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { RespostasPersonalizadasIzzaInicial } from "../models/respostasPersonalizadasIzzaModel"
import { RespostasPersonalizadasIzzaActionsTypes } from "./respostasPersonalizadasIzzaActions"
import { RespostasPersonalizadasIzzaContext } from "./RespostasPersonalizadasIzzaContext"
import { respostasPersonalizadasIzzaReducer } from "./respostasPersonalizadasIzzaReducer"

export function RespostasPersonalizadasIzzaContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        respostasPersonalizadasIzzaReducer,
        RespostasPersonalizadasIzzaInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterRespostasIzza(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: RespostasPersonalizadasIzzaActionsTypes.CARREGAR,
                    payload: response,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const { modoIzza: _, ...payload } = dados
            const response = await salvarRespostasIzza(autorizacao, payload)
            if (typeof response === "object" && "retornoErro" in response) {
                enqueueSnackbar(response.mensagem || "Erro ao salvar", { variant: "error" })
            } else {
                enqueueSnackbar("Mensagens atualizadas com sucesso!", { variant: "success" })
            }
        } catch {
            enqueueSnackbar("Erro ao salvar", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }, [dados])

    return (
        <RespostasPersonalizadasIzzaContext.Provider
            value={{ dados, dispatch, erroCarregamento, salvar }}
        >
            <Loading />
            {children}
        </RespostasPersonalizadasIzzaContext.Provider>
    )
}
